import * as TYPES from './types';
export default {
    [TYPES.SET_LISTING](state, payload) {
        state.listing = [...payload];
    }
};
